import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Span } from '@piconetworks/pkg-text';
import styles from './Badge.module.scss.js';

var _excluded = ["as", "caps", "children", "className", "variant"];

var Badge = function Badge(_ref) {
  var as = _ref.as,
      caps = _ref.caps,
      children = _ref.children,
      className = _ref.className,
      variant = _ref.variant,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var Component = as || Span;
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cx(styles.badge, variant && styles[variant], caps && styles.caps, className)
  }, props), "\xA0", children);
};

Badge.propTypes = {
  as: PropTypes.any,
  caps: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light', 'link', 'facebook', 'github', 'google', 'linkedin', 'twitter'])
};
Badge.defaultProps = {
  caps: true
};

export { Badge as default };
//# sourceMappingURL=index.js.map
